angular
    .module('webcomm').filter('sharingLocation', function() {
        return function(input) {
            var out = {};

            angular.forEach(input, (value, key) => {
                if (value && value.hasOwnProperty('location') && value.location)
                    out[key] = value;
            });

            return out;
        }
    });